import { render, staticRenderFns } from "./draggableImageItem.vue?vue&type=template&id=27bda37a&scoped=true"
import script from "./draggableImageItem.vue?vue&type=script&lang=js"
export * from "./draggableImageItem.vue?vue&type=script&lang=js"
import style0 from "./draggableImageItem.vue?vue&type=style&index=0&id=27bda37a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bda37a",
  null
  
)

export default component.exports